import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://www.bahrululumic.com';
const SITE_NAME = 'Bahrul Ulum Islamic Centre';
const DEFAULT_IMAGE = `${SITE_URL}/og-default.svg`;

const MetaTags = ({ 
  title, 
  description, 
  keywords, 
  image, 
  url,
  type = 'website',
  author,
  publishDate
}) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const ogImage = image || DEFAULT_IMAGE;
  const ogUrl = url || SITE_URL;
  const ogDescription = description || 'Building Unique and Innovative Communities';

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={ogDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={ogUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={ogUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={ogDescription} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="id_ID" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={ogUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={ogDescription} />
      <meta name="twitter:image" content={ogImage} />
      
      {/* Article specific */}
      {type === 'article' && publishDate && (
        <meta property="article:published_time" content={publishDate} />
      )}
      {type === 'article' && author && (
        <meta property="article:author" content={author} />
      )}
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": type === 'article' ? 'Article' : 'WebPage',
          "name": fullTitle,
          "headline": title,
          "description": ogDescription,
          "image": ogImage,
          "url": ogUrl,
          ...(type === 'article' && {
            "datePublished": publishDate,
            "author": {
              "@type": "Person",
              "name": author || "Admin Bahrul Ulum"
            }
          }),
          "publisher": {
            "@type": "Organization",
            "name": SITE_NAME,
            "logo": {
              "@type": "ImageObject",
              "url": `${SITE_URL}/yayasan-logo.png`
            }
          }
        })}
      </script>
    </Helmet>
  );
};

export default MetaTags;
